import { Calendar as PrimereactCalendar } from 'primereact/calendar';
import { ReactComponent as ValidationErrorIcon } from '../../assets/images/validation-error.svg';
import { ReactComponent as CalendarIcon } from '../../assets/images/calendar-icon.svg';
import { ReactComponent as TimeIcon } from '../../assets/images/clock.svg';
import { Constants } from '../../utils/Constants';
import { useRef } from 'react';
import { classNames } from 'primereact/utils';

const Calendar = ({showLabel = true, label, validator, validations, readOnlyInput=true, showButtonBar=true, dateFormat=Constants.DATE_FORMAT_CALENDAR, ...rest}) => {
    const ref = useRef();

    const id = `calendar-${rest.id}`;
    const validationMessage = validator ? validator.message(id, label, rest.value, validations) : null;
    let className = rest?.className || '';
    const inputIsSmall = typeof rest.inputClassName === 'string' && rest.inputClassName.includes('small');
    if (inputIsSmall) {
        className += ' small';
    }
    return (
        <div className={classNames({'field': showLabel})}>
            {showLabel && <label htmlFor={id}>{label}</label>}
            <span className="p-input-icon-left w-full">
                <PrimereactCalendar {...rest} id={id} className={classNames('w-full', className)} ref={ref} 
                    readOnlyInput={readOnlyInput} showButtonBar={showButtonBar} dateFormat={dateFormat} small={inputIsSmall}
                    panelClassName={classNames({'small': inputIsSmall})}
                />
                {rest.timeOnly && <TimeIcon className={classNames('cursor-pointer', {'small': inputIsSmall})} onClick={e => {
                    if (rest.disabled) {
                        return;
                    }
                    ref.current.show();
                }}/>}
                {!rest.timeOnly && <CalendarIcon className={classNames('cursor-pointer', {'small': inputIsSmall})} onClick={e => {
                    if (rest.disabled) {
                        return;
                    }   
                    ref.current.show();
                }}/>}
            </span>

            {validationMessage && <div className={"validation-error"}>
                <ValidationErrorIcon className='icon'/>
                <div className="text">{validationMessage}</div>
            </div>}
        </div>
    )
}

export default Calendar;